import { NgModule } from "@angular/core";

import { WorkplaceService } from "./workplace.service";
import { ActivityTypeService } from "./activity-type.service";
import { PersonService } from "./person.service";
import { WorkgroupService } from "./workgroup.service";
import { ActivityService } from "./activity.service";
import { JobTypeService } from "./job-type.service";
import { ActivityRemarkService } from "./activity-remark.service";
import { ActivityAdjustmentService } from "./activity-adjustment.service";

@NgModule({
    providers: [
        PersonService,
        WorkplaceService,
        WorkgroupService,
        ActivityService,
        ActivityTypeService,
        JobTypeService,
        ActivityRemarkService,
        ActivityAdjustmentService
    ]
})
export class ServicesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/services.module.ts